import React, {useState, useEffect} from 'react';
import {useRouteMatch, useHistory} from 'react-router-dom';
import {observer} from 'mobx-react-lite';
import {Button} from 'react-bootstrap';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import {useStore} from '../../../../store';
import {Wrap} from './style';
import cmeIcon from '../../../../assets/icons/icon_CME.svg';
// import {TitleDiv} from '../../elements/video';

const ReflectiveLearning = observer(({expanded}) => {
  // const location = useHistory();
  const {accountStore, videoStore, cmeStore} = useStore();
  const {account} = accountStore;
  const {video} = videoStore;
  const {setVideoId} = cmeStore;

  const match = useRouteMatch();
  const location = useHistory();
  const [canAccess, setCanAccess] = useState(true);
  const [userStatus, setUserStatus] = useState(false);

  // const getRemainingDays = (date: Date) =>
  //   date ? Math.floor((new Date(date).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) : 0;

  useEffect(() => {
    const {id} = match.params;
    if (id) {
      setVideoId(id);
    }
  }, [match.params, setVideoId]);

  // useEffect(() => {
  //   if (UserCme?.completed_at) {
  //     setshowComplete(true);
  //   }
  // }, [setshowComplete, UserCme?.completed_at]);

  useEffect(() => {
    if (
      (!account.subscription ||
        (account.subscription.status === 'cancelled' && !account.subscription.name) ||
        account.subscription.status === 'trialing') &&
      !account.access
    ) {
      setCanAccess(false);
    } else setCanAccess(true);
  }, [account]);

  // const [isAssessmentDisabled, setAssessmentDisabled] = useState(false);

  // useEffect(() => {
  //   if (
  //     !video?.organizationCME ||
  //     getRemainingDays(video?.organizationCME?.withdraw_at) < 0 ||
  //     getRemainingDays(video?.organizationCME?.cme_expire_at) < 0
  //   ) {
  //     setAssessmentDisabled(true);
  //   } else {
  //     setAssessmentDisabled(false);
  //   }
  // }, [video]);

  useEffect(() => {
    if (
      account?.subscription?.name?.includes('Premium') ||
      (account?.access?.status === 'Active' && account?.access?.cme)
    ) {
      setUserStatus('active');
    } else if (!account.access) setUserStatus('subscriptionInactive');
    else setUserStatus('accessInactive');
  }, [account]);

  const onClickUpgrade = () => {
    location.push('/profile/subscription');
  };
  const onReflect = () => {
    const reflectUrl = `https://reflectl.ink/jLc99LP1KlYv5y26Q8MN&lrnr_tag=${account.id}_${video.id}`;

    window.open(reflectUrl, '_blank');
  };
  return (
    <Wrap className={classNames({expanded})}>
      {userStatus === 'active' ? (
        // Beta CME page
        <div className="cme-content-container">
          <h6>{video.title}</h6>
          <br />
          <p style={{fontSize: '14px', fontWeight: '200'}}>
            This experience is powered by CMEfy—discover unlimited opportunities to capture reflection at the point of
            inspiration, point of care. Unlock continuing education credits via an accredited activity portal designed
            for busy Dentists, Nurses, Nurse Practitioners, Pharmacists, and members of the healthcare team.
          </p>
          <p style={{fontWeight: '100', fontSize: '15px'}}>
            Learn more at <a href="https://about.cmefy.com/cme-info">about.cmefy.com/cme-info</a>
          </p>
          {canAccess ? (
            <Button
              variant="primary"
              type="button"
              className="a_reflectButton py-0"
              onClick={() => {
                onReflect();
              }}
            >
              Reflect Now
            </Button>
          ) : (
            <Button variant="primary" type="button" className="a_reflectButton py-0" disabled>
              Reflect Now
            </Button>
          )}
        </div>
      ) : (
        userStatus === 'subscriptionInactive' && (
          <div className="d-flex flex-column align-items-center">
            <div className="a_iconDiv d-flex align-items-center justify-content-center">
              <img src={cmeIcon} alt="CME" className="a_cmeIcon" />
            </div>
            <br />
            <p className="a_cmeUpgradeText">Upgrade to a Premium Account</p>
            <Button variant="primary" type="button" className="a_upgradeButton py-0" onClick={() => onClickUpgrade()}>
              Upgrade
            </Button>
          </div>
        )
      )}
      {userStatus === 'accessInactive' ? (
        <div className="d-flex flex-column align-items-center">
          <div className="a_iconDiv d-flex align-items-center justify-content-center">
            <img src={cmeIcon} alt="CME" className="a_cmeIcon" />
          </div>
          <p className="a_cmeUpgradeHeading">Not Available</p>
          <p className="a_cmeUpgradeText">
            This feature is not available with your current plan. Please ask your administrator to contact GIBLIB to
            potentially add this feature.
          </p>
        </div>
      ) : null}
    </Wrap>
  );
});

ReflectiveLearning.propTypes = {
  expanded: PropTypes.bool,
  title: PropTypes.string,
};
ReflectiveLearning.defaultProps = {
  expanded: false,
  title: '',
};

export default ReflectiveLearning;
